import styled from 'styled-components';

import { Text } from '@/nova/components';
import { COLORS, SPACE } from '@/nova/theme/tokens';
import { OpenLink as SheetOpenLink } from '@/nova/pages/creatives/components/LinkDestinationSheet/LinkDestinationSheet.styles';

/* The campaign form's "Where affiliates send players": a label over the tracking-link destination sheet's accordion
   (its sections and rows come from that sheet's styles). */

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const Label = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

/** The dark well the accordion sits in, so the choice reads as one group inside the form. The horizontal padding
 *  clears the sections' own -12px bleed, so an open section's darker card stays inside the well. */
export const Well = styled.div`
  padding: ${SPACE[4]} ${SPACE[16]};
  border-radius: 16px;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.ingredientOpenBg};

  /* The first section's divider would double the well's own top border. */
  section:first-of-type::before {
    display: none;
  }
`;

/** A row's "open in a new tab" link. The radio sits at the row's left here, so the link's slot is the row's last item:
 *  its right edge is the row's padding plus border (8 + 1 = 9px, off the scale: it lines the link up with the slot). */
export const OpenLink = styled(SheetOpenLink)`
  right: 9px;
`;
